import { MESSAGE_TYPES } from '../../item/message-types';
import { AbstractChatMessage } from '../message/abstract-chat-message';
import { QuizContentType } from '../../classes/message/quiz-content-type';
export interface QuizAnswer {
    text: string;
    isCorrect: boolean;
}

export class QuizMessage extends AbstractChatMessage {
    question: string;
    answers: QuizAnswer[];
    correctAnswerIndex: number;
    content: QuizContentType;

    constructor(){
        super()
        this.setType(MESSAGE_TYPES.Quiz)
    }

} 